import { ParkTimeContractType } from '@repo/domain';
import { CalendarMinusIcon, ClockIcon } from '@repo/icons';
import { tr } from '@repo/locale';
import { type TestId } from '@repo/test-id';
import { Badge } from '@repo/ui';

interface Props {
  type: ParkTimeContractType;
  onSwitch: (type: ParkTimeContractType) => void;
  testId: TestId;
}

export default function TimeContractToggle({ type, onSwitch: onChange, testId }: Props) {
  const handleSwitchPickerModeTo = (newType: ParkTimeContractType) => {
    onChange(newType);
  };

  return (
    <>
      <button
        onClick={() => handleSwitchPickerModeTo(ParkTimeContractType.FixedDuration)}
        className="cursor-pointer"
        aria-label={tr('parking_search:park_duration.mode.select_hours')}
      >
        <Badge
          label={tr('parking_search:park_duration.mode.hours')}
          leftIcon={ClockIcon}
          color={type === ParkTimeContractType.FixedDuration ? 'brand' : 'white'}
          testId={testId.append('hours')}
        />
      </button>
      <button
        onClick={() => handleSwitchPickerModeTo(ParkTimeContractType.FixedEnd)}
        className="cursor-pointer"
        aria-label={tr('parking_search:park_duration.mode.select_days')}
      >
        <Badge
          label={tr('parking_search:park_duration.mode.days')}
          leftIcon={CalendarMinusIcon}
          color={type === ParkTimeContractType.FixedEnd ? 'brand' : 'white'}
          testId={testId.append('days')}
        />
      </button>
    </>
  );
}
